//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const qaIcon = require("@/assets/loanBindCard/qaIcon@2x.png");
const qaIconKoo = require("@/assets/loanBindCard/qaIcon-koo@2x.png");
export default {
    name: "offlineRepayQuestions",
    data() {
        return {
            qaIcon,
            qaIconKoo,
            qaList: [
                {
                    q: "<span>Q</span>是否必须使用本人银行卡",
                    a: "<span>A</span>必须使用您本人开户的银行卡进行转账",
                },
                {
                    q: "<span>Q</span>转账成功后未收到还款成功通知",
                    a: "<span>A</span>若您选择转账还款，请务必点击“转账还款登记”，完成还款登记",
                },
                {
                    q: "<span>Q</span>转账金额与还款金额的关系",
                    a: "<span>A</span>请确保转账金额与登记的还款金额保持一致，否则会还款失败",
                },
                {
                    q: "<span>Q</span>登记成功，转账时效要求",
                    a: "<span>A</span>登记成功后，请于当天9点-22点间完成转账操作。考虑到对公转账入账时效性，为避免借款逾期，建议登记当天22点前完成转账操作",
                },
                {
                    q: "<span>Q</span>转账成功后，何时还款成功",
                    a: "<span>A</span>用户已登记并转账成功，预计还款成功时间<br/>-当天0点-9点间完成转账，预计9点后完成还款<br/>-当天9点-22点间完成转账，预计转账成功后1小时完成还款<br/>-当天22点-24点间完成转账，预计第二天9点后完成还款<br/>为避免借款逾期，建议登记当天22点前完成转账操作",
                },
                {
                    q: "<span>Q</span>还款金额超过银行卡单笔/单日转账限额",
                    a: "<span>A</span>建议联系发卡银行或通过银行APP，修改单笔/单日的转账限额",
                },
            ],
            themeType: '',
        };
    },
    created () {
      const {
        themeType,
      } = this.$route.query;
      this.themeType = themeType;
    }
};
